<template>
  <div class="watermark-layer" aria-hidden="true">
    <span
      v-for="n in watermarkCount"
      :key="n"
      class="watermark-text"
      :style="watermarkStyle(n)"
    >{{ text }}</span>
  </div>
</template>

<script setup>
import { computed } from 'vue'

defineOptions({
  name: 'Watermark'
})

const props = defineProps({
  userInfoKey: {
    type: String,
    default: 'userDetail'
  },
  nameKey: {
    type: String,
    default: 'userName'
  },
  deptKeys: {
    type: Array,
    default: () => ['depts.0.orgName', 'deptName', 'department']
  },
  rows: {
    type: Number,
    default: 4
  },
  perRow: {
    type: Number,
    default: 3
  },
  rowGap: {
    type: Number,
    default: 25
  },
  colGap: {
    type: Number,
    default: 30
  },
  oddRowOffset: {
    type: Number,
    default: 15
  }
})

const WATERMARK_ANGLE = -24
const WATERMARK_FONT_SIZE = 14
const WATERMARK_COLOR = 'rgba(0, 0, 0, 0.12)'

const text = computed(() => {
  try {
    const raw = typeof window !== 'undefined'
      ? localStorage.getItem(props.userInfoKey)
      : null
    const userInfo = raw ? JSON.parse(raw) : {}
    const name = userInfo?.[props.nameKey] || userInfo?.userName || userInfo?.realName || ''
    const dept = props.deptKeys
      .map((key) => {
        const path = key.split('.')
        let value = userInfo
        for (const segment of path) {
          value = value?.[segment]
        }
        return value
      })
      .find((item) => Boolean(item)) || ''
    const parts = [name, dept].filter(Boolean)
    return parts.length ? parts.join('-') : ''
  } catch {
    return ''
  }
})

const watermarkCount = computed(() => props.rows * props.perRow)

const watermarkStyle = (n) => {
  const row = Math.floor((n - 1) / props.perRow)
  const col = (n - 1) % props.perRow
  const top = `${row * props.rowGap}%`
  const left = `${col * props.colGap + (row % 2 ? props.oddRowOffset : 0)}%`
  return { top, left }
}
</script>

<style scoped lang="scss">
.watermark-layer {
  position: fixed;
  inset: 0;
  pointer-events: none;
  z-index: 9999;
  overflow: hidden;
}

.watermark-text {
  position: absolute;
  transform-origin: 0 0;
  transform: rotate(-24deg);
  font-size: 14px;
  color: rgba(0, 0, 0, 0.12);
  white-space: nowrap;
  user-select: none;
}
</style>
